// extracted by mini-css-extract-plugin
module.exports = {"navListItem":"header_navListItem__tUYne","vinylImg":"header_vinylImg__2inP7"};